import axiosInstance from "@/api/axiosInstance";
import { HeroItemListResponse } from "../types";

/**
 * Fetch all hero items for admin management
 * GET /api/admin/hero-items
 */
export async function fetchHeroItems(): Promise<HeroItemListResponse> {
  const response = await axiosInstance.get<HeroItemListResponse>(
    "/api/admin/hero-items",
  );
  return response.data;
}
